<script lang="ts">
    import Sort from '$saga/views/Search/components/Sort.svelte';

    // import { filtersContext } from '$saga/views/Search/store';
    // import Button from '$saga/components/Button.svelte';
</script>

<div
    class="ml-auto hidden flex-wrap items-center justify-between gap-m desktop:flex"
>
    <!--<Button-->
    <!--    type="button"-->
    <!--    intent="secondary"-->
    <!--    size="small"-->
    <!--    shape="rounded"-->
    <!--    class="ml-auto text-content-brand"-->
    <!--    on:click={() => {-->
    <!--        $filtersContext.hideVerticalBar = !$filtersContext.hideVerticalBar;-->
    <!--    }}-->
    <!--&gt;-->
    <!--    {#if $filtersContext.hideVerticalBar}-->
    <!--        Filtres-->
    <!--    {:else}-->
    <!--        Fermer les filtres-->
    <!--    {/if}-->
    <!--</Button>-->
    <!-- sort on desktop -->
    <div class="ml-auto">
        <Sort />
    </div>
</div>
